/*
  Grafilabel offertepaneel

  1. Legt de bron van de bezoeker vast (UTM, Google Ads klik-id, organisch of verwijzing),
     zodat elke offerteaanvraag de leadbron meestuurt.
  2. Opent het offertepaneel bij een klik op [data-gl-quote] en vult het product in.
  3. Na verzenden laadt Shopify de pagina opnieuw (?contact_posted=true). Dan opent het
     paneel weer met de bedankmelding, of met de foutmelding als er iets niet klopte.

  Opslag (localStorage/sessionStorage) zit overal in try/catch: in een privévenster of met
  geblokkeerde cookies werkt het formulier gewoon, alleen zonder bron.
*/
(function () {
  if (window.GlQuote) return;

  var SOURCE_KEY = 'gl_quote_source';
  var SENT_KEY = 'gl_quote_sent';
  var SOURCE_TTL = 90 * 24 * 60 * 60 * 1000;

  function store(type) {
    try {
      return window[type];
    } catch (e) {
      return null;
    }
  }
  function read(type, key) {
    var s = store(type);
    if (!s) return null;
    try {
      return JSON.parse(s.getItem(key) || 'null');
    } catch (e) {
      return null;
    }
  }
  function write(type, key, value) {
    var s = store(type);
    if (!s) return;
    try {
      if (value === null) s.removeItem(key);
      else s.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  /* 1. Bron vastleggen
     Laatste niet-directe bron wint (zoals Google Analytics het ook telt): een nieuw
     campagnebezoek overschrijft de vorige bron, een direct bezoek niet. */
  function captureSource() {
    var params = new URLSearchParams(window.location.search);
    var current = read('localStorage', SOURCE_KEY);
    if (current && Date.now() - (current.t || 0) > SOURCE_TTL) current = null;

    var record = null;
    var clickIds = ['gclid', 'gbraid', 'wbraid', 'msclkid', 'fbclid'];
    var click = '';
    clickIds.forEach(function (k) {
      if (!click && params.get(k)) click = k;
    });

    if (params.get('utm_source') || click) {
      record = {
        source: params.get('utm_source') || (click === 'msclkid' ? 'bing' : click === 'fbclid' ? 'facebook' : 'google'),
        medium: params.get('utm_medium') || (click === 'fbclid' ? 'paid social' : 'cpc'),
        campaign: params.get('utm_campaign') || '',
        term: params.get('utm_term') || '',
        click: click
      };
    } else if (document.referrer) {
      var host = '';
      try {
        host = new URL(document.referrer).hostname.replace(/^www\./, '');
      } catch (e) {}
      if (host && host !== window.location.hostname.replace(/^www\./, '') && !/(^|\.)shopify\.com$|(^|\.)myshopify\.com$/.test(host)) {
        var organic = /(^|\.)(google|bing|duckduckgo|yahoo|ecosia|startpage)\./.test(host);
        record = { source: host, medium: organic ? 'organisch' : 'verwijzing', campaign: '', term: '', click: '' };
      }
    }

    if (record) {
      record.landing = window.location.pathname;
      record.t = Date.now();
      write('localStorage', SOURCE_KEY, record);
    } else if (!current) {
      write('localStorage', SOURCE_KEY, {
        source: 'direct',
        medium: 'geen',
        campaign: '',
        term: '',
        click: '',
        landing: window.location.pathname,
        t: Date.now()
      });
    }
  }

  function sourceText() {
    var r = read('localStorage', SOURCE_KEY);
    if (!r) return 'onbekend';
    var parts = [r.source + ' / ' + r.medium];
    if (r.campaign) parts.push('campagne: ' + r.campaign);
    if (r.term) parts.push('zoekwoord: ' + r.term);
    if (r.click) parts.push('klik-id: ' + r.click);
    if (r.landing) parts.push('eerste pagina: ' + r.landing);
    if (r.t) {
      var d = new Date(r.t);
      parts.push('datum: ' + d.getDate() + '-' + (d.getMonth() + 1) + '-' + d.getFullYear());
    }
    return parts.join(' | ');
  }

  /* 2. Formulier vullen */
  function absoluteUrl(path) {
    if (!path) return '';
    try {
      return new URL(path, window.location.origin).href;
    } catch (e) {
      return path;
    }
  }

  function fillForm(form, data) {
    data = data || {};
    var title = data.title || '';
    var set = function (name, value) {
      var input = form.querySelector('[data-gl-quote-input="' + name + '"]');
      if (input) input.value = value || '';
    };
    set('title', title);
    set('sku', data.sku);
    set('url', absoluteUrl(data.url));
    set('page', window.location.href.split('#')[0]);
    set('source', sourceText());

    var card = form.querySelector('[data-gl-quote-product]');
    var field = form.querySelector('[data-gl-quote-product-field]');
    var fieldInput = field ? field.querySelector('input') : null;
    if (card) {
      card.hidden = !title;
      var t = card.querySelector('[data-gl-quote-product-title]');
      if (t) t.textContent = title;
      var s = card.querySelector('[data-gl-quote-product-sku]');
      if (s) {
        s.textContent = data.sku ? 'Artikelnummer ' + data.sku : '';
        s.hidden = !data.sku;
      }
      var img = card.querySelector('[data-gl-quote-image]');
      if (img) {
        if (data.image) {
          img.src = data.image;
          img.hidden = false;
        } else {
          img.hidden = true;
        }
      }
    }
    if (field) {
      field.hidden = !!title;
      if (fieldInput) fieldInput.required = !title;
    }
  }

  function showState(form, state, data) {
    var success = form.querySelector('[data-gl-quote-success]');
    var fields = form.querySelector('[data-gl-quote-fields]');
    if (!success || !fields) return;
    var ok = state === 'success';
    success.hidden = !ok;
    fields.hidden = ok;
    var p = success.querySelector('[data-gl-quote-success-product]');
    if (p) p.textContent = ok && data && data.title ? ' voor ' + data.title : '';
    var submit = form.querySelector('[data-gl-quote-submit]');
    if (submit) {
      submit.disabled = false;
      var label = submit.querySelector('[data-gl-quote-submit-label]');
      if (label) label.textContent = 'Offerte aanvragen';
    }
  }

  function bindSubmit(form) {
    if (form.dataset.glQuoteBound) return;
    form.dataset.glQuoteBound = 'true';
    form.addEventListener('submit', function () {
      var get = function (name) {
        var input = form.querySelector('[data-gl-quote-input="' + name + '"]');
        return input ? input.value : '';
      };
      var card = form.querySelector('[data-gl-quote-image]');
      write('sessionStorage', SENT_KEY, {
        form: form.id,
        title: get('title'),
        sku: get('sku'),
        url: get('url'),
        image: card && !card.hidden ? card.getAttribute('src') : ''
      });
      var submit = form.querySelector('[data-gl-quote-submit]');
      if (submit) {
        submit.disabled = true;
        var label = submit.querySelector('[data-gl-quote-submit-label]');
        if (label) label.textContent = 'Bezig met versturen…';
      }
    });
  }

  /* 3. Het paneel */
  if (!customElements.get('gl-quote-drawer')) {
    customElements.define(
      'gl-quote-drawer',
      class GlQuoteDrawer extends HTMLElement {
        connectedCallback() {
          this.panel = this.querySelector('.gl-quote-drawer__panel');
          this.form = this.querySelector('form');
          if (this.form) bindSubmit(this.form);
          this.addEventListener('click', (e) => {
            if (e.target.closest('[data-gl-quote-close]')) {
              e.preventDefault();
              this.close();
            }
          });
          this.onKeydown = this.onKeydown.bind(this);
        }

        open(data, trigger, state) {
          if (!this.form) return;
          this.trigger = trigger || document.activeElement;
          if (data) fillForm(this.form, data);
          showState(this.form, state || 'form', data);
          this.hidden = false;
          document.documentElement.classList.add('gl-quote-lock');
          requestAnimationFrame(() => {
            this.classList.add('is-open');
            var target = state === 'success' ? this.querySelector('[data-gl-quote-success]') : this.panel;
            if (target) target.focus({ preventScroll: true });
          });
          document.addEventListener('keydown', this.onKeydown);
          if (window.dataLayer && state !== 'success') {
            window.dataLayer.push({ event: 'offerte_paneel_geopend', offerte_product: (data && data.title) || '' });
          }
        }

        close() {
          this.classList.remove('is-open');
          document.removeEventListener('keydown', this.onKeydown);
          document.documentElement.classList.remove('gl-quote-lock');
          window.setTimeout(() => {
            if (!this.classList.contains('is-open')) this.hidden = true;
          }, 260);
          if (this.trigger && typeof this.trigger.focus === 'function') this.trigger.focus({ preventScroll: true });
        }

        onKeydown(e) {
          if (e.key === 'Escape') {
            this.close();
            return;
          }
          if (e.key !== 'Tab') return;
          var focusable = Array.prototype.filter.call(
            this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), textarea, select, [tabindex="0"]'),
            function (el) {
              return el.offsetParent !== null;
            }
          );
          if (!focusable.length) return;
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    );
  }

  function drawer() {
    return document.querySelector('gl-quote-drawer');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-gl-quote]');
    if (!trigger) return;
    var d = drawer();
    if (!d || typeof d.open !== 'function') return;
    e.preventDefault();
    e.stopPropagation();
    d.open(
      {
        title: trigger.dataset.title,
        sku: trigger.dataset.sku,
        url: trigger.dataset.url,
        image: trigger.dataset.image
      },
      trigger
    );
  });

  /* 4. Na verzenden, en de offertepagina */
  function afterLoad() {
    captureSource();

    document.querySelectorAll('form[data-gl-quote-form]').forEach(function (form) {
      bindSubmit(form);
      if (form.getAttribute('data-gl-quote-form') === 'page') {
        var params = new URLSearchParams(window.location.search);
        fillForm(form, { title: params.get('product') || '', sku: params.get('sku') || '' });
      }
    });

    var sent = read('sessionStorage', SENT_KEY);
    if (!sent || !sent.form) return;
    var form = document.getElementById(sent.form);
    if (!form) return;
    var state = form.querySelector('[data-gl-quote-state]');
    var posted = state && state.getAttribute('data-posted') === 'true';
    var errors = state && state.getAttribute('data-errors') === 'true';
    if (!posted && !errors) return;
    write('sessionStorage', SENT_KEY, null);

    var isDrawer = form.getAttribute('data-gl-quote-form') === 'drawer';
    if (posted) {
      if (window.dataLayer) window.dataLayer.push({ event: 'generate_lead', lead_type: 'offerte', offerte_product: sent.title || '' });
      if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { lead_type: 'offerte', offerte_product: sent.title || '' });
    }
    if (isDrawer) {
      var d = drawer();
      if (d && typeof d.open === 'function') d.open(sent, null, posted ? 'success' : 'form');
    } else {
      fillForm(form, sent);
      showState(form, posted ? 'success' : 'form', sent);
      form.scrollIntoView({ block: 'start' });
    }

    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('contact_posted');
      url.hash = '';
      window.history.replaceState(null, '', url.pathname + url.search);
    } catch (e) {}
  }

  window.GlQuote = { open: function (data) { var d = drawer(); if (d) d.open(data); } };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', afterLoad);
  } else {
    afterLoad();
  }
})();
